import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { Card, Box, Typography, CircularProgress } from "@mui/material";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ProductionCardRAP from "layouts/site-dashboard/components/ProductionCardRAP";
import ProductionCardAsp from "layouts/site-dashboard/components/ProductionCardAsp";
import AnnualPlantStatus from "layouts/site-dashboard/components/AnnualPlantStatus";
import LivePlantStatus from "layouts/site-dashboard/components/LivePlantStatus";
import SiteInformation from "layouts/site-dashboard/components/SiteInformation";
import UsageCard from "layouts/site-dashboard/components/UsageCard";
import StockedMaterials from "layouts/site-dashboard/components/StockedMaterials";
import ConditionMonitoring from "layouts/site-dashboard/components/ConditionMonitoring";
import AsphaltBatchQuality from "layouts/site-dashboard/components/AsphaltBatchQuality";
import { useParams } from "react-router-dom";
import fetchAnnualTotalisersData from "./data/fetchAnnualTotalisersData";
import AnnualTotalisersChart from "./data/AnnualTotalisersChart";
import ProductionCardGraded from "layouts/site-dashboard/components/ProductionCardGraded";
import ProductionCardRawMat from "layouts/site-dashboard/components/ProductionCardRawMat";
import ProductionCardSand from "layouts/site-dashboard/components/ProductionCardSand";
import ProductionCardShipLoad from "layouts/site-dashboard/components/ProductionCardShipLoad";
import ProductionCardShipUnload from "layouts/site-dashboard/components/ProductionCardShipUnload";
import ProductionCardTrainLoad from "layouts/site-dashboard/components/ProductionCardTrainLoad";
import ProductionCardShiptoShore from "layouts/site-dashboard/components/ProductionCardShiptoShore";
import PpmSummary from "layouts/site-dashboard/components/PpmSummary";
import { StarBorder } from "@mui/icons-material";

function Dashboard() {
  const [dashboardConfig, setDashboardConfig] = useState(null);
  const [annualTotalisersData, setAnnualTotalisersData] = useState(null);
  const [stockedMaterialsData, setStockedMaterialsData] = useState([]);
  const [siteType, setSiteType] = useState(null);
  const [siteData, setSiteData] = useState(null);
  const [timestamp, setTimestamp] = useState("");
  const [rapData, setRapData] = useState({
    dayProgress: 0,
    weekProgress: 0,
    monthProgress: 0,
    yearProgress: 0,
  });
  const [annualPlantStatusData, setannualPlantStatusData] = useState({
    Production_Hrs: 0,
    Idle_Hrs: 0,
    Breakdown_Hrs: 0,
    Offline_Hrs: 0,
  });
  const [livePlantStatusData, setlivePlantStatusData] = useState(null);

  const [asphaltData, setAsphaltData] = useState({
    dayProgress: 0,
    weekProgress: 0,
    monthProgress: 0,
    yearProgress: 0,
  });
  const [RawMaterialData, setRawMaterialData] = useState({
    dayProgress: 0,
    weekProgress: 0,
    monthProgress: 0,
    yearProgress: 0,
  });
  const [SandData, setSandData] = useState({
    dayProgress: 0,
    weekProgress: 0,
    monthProgress: 0,
    yearProgress: 0,
  });
  const [GradedData, setGradedData] = useState({
    dayProgress: 0,
    weekProgress: 0,
    monthProgress: 0,
    yearProgress: 0,
  });
  const [ShiptoShoreData, setShiptoShoreData] = useState({
    dayProgress: 0,
    weekProgress: 0,
    monthProgress: 0,
    yearProgress: 0,
  });
  const [TrainLoadData, setTrainLoad] = useState({
    dayProgress: 0,
    weekProgress: 0,
    monthProgress: 0,
    yearProgress: 0,
  });
  const [ShipLoadData, setShipLoad] = useState({
    dayProgress: 0,
    weekProgress: 0,
    monthProgress: 0,
    yearProgress: 0,
  });
  const [ShipUnloadData, setShipUnload] = useState({
    dayProgress: 0,
    weekProgress: 0,
    monthProgress: 0,
    yearProgress: 0,
  });
  const [usageData, setUsageData] = useState({
    unusedAgg: 0,
    gas: 0,
    burnerIdleFuel: 0,
    fuel: 0,
    electricityOffline: 0,
    electricity: 0,
    productionElectricity: 0,
    idleElectricity: 0,
  });

  const [batchQualityData, setBatchQualityData] = useState({
    Day_Good_Quality: 0,
    Day_Bad_Quality: 0,
    Week_Good_Quality: 0,
    Week_Bad_Quality: 0,
    Month_Good_Quality: 0,
    Month_Bad_Quality: 0,
    Year_Good_Quality: 0,
    Year_Bad_Quality: 0,
  });
  const [loading, setLoading] = useState(true);
  const { site_id } = useParams();

  // Fetch site data
  useEffect(() => {
    setLoading(true);

    const fetchGatewayName = async () => {
      try {
        const response = await fetch(
          `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/gateway/profile?site_id=${site_id}`
        );
        const data = await response.json();
        return data[0].name;
      } catch (error) {
        console.error("Error fetching gateway name:", error.message);
        return null;
      }
    };

    const fetchSiteData = async () => {
      try {
        const response = await fetch(
          `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/site/profile?site_id=${site_id}`
        );
        const data = await response.json();
        setSiteData(data);
        setDashboardConfig(data.dashboard_config || []);
        setSiteType(data.site_type || null);
        return data.site_type || null;
      } catch (error) {
        console.error("Error fetching site data:", error.message);
        return null;
      }
    };

    const fetchTimestreamData = async (siteType) => {
      const gatewayName = await fetchGatewayName();

      if (!gatewayName) {
        console.error("Failed to fetch gateway name");
        setLoading(false);
        return;
      }

      try {
        // Build the URL with or without site_type
        let url = `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/query-timestream?query_type=site_dashboard&thing_name=${encodeURIComponent(
          gatewayName
        )}`;

        if (siteType) {
          url += `&site_type=${siteType}`;
        }
        console.log(url);
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        setStockedMaterialsData(data.stocked_materials || []);
        setlivePlantStatusData(data.plant_status);
        setTimestamp(new Date(data.timestamp).toLocaleString());

        if (data.rap_data) {
          setRapData({
            dayProgress: data.rap_data.dayProgress,
            weekProgress: data.rap_data.weekProgress,
            monthProgress: data.rap_data.monthProgress,
            yearProgress: data.rap_data.yearProgress,
            maxDayValue: data.rap_data.maxDayValue,
            maxWeekValue: data.rap_data.maxWeekValue,
            maxMonthValue: data.rap_data.maxMonthValue,
            maxYearValue: data.rap_data.maxYearValue,
          });
        }

        if (data.asphalt_data) {
          setAsphaltData({
            dayProgress: data.asphalt_data.dayProgress,
            weekProgress: data.asphalt_data.weekProgress,
            monthProgress: data.asphalt_data.monthProgress,
            yearProgress: data.asphalt_data.yearProgress,
          });
        }

        if (data.raw_material_data) {
          setRawMaterialData({
            dayProgress: data.raw_material_data.dayProgress,
            weekProgress: data.raw_material_data.weekProgress,
            monthProgress: data.raw_material_data.monthProgress,
            yearProgress: data.raw_material_data.yearProgress,
          });
        }

        if (data.sand_data) {
          setSandData({
            dayProgress: data.sand_data.dayProgress,
            weekProgress: data.sand_data.weekProgress,
            monthProgress: data.sand_data.monthProgress,
            yearProgress: data.sand_data.yearProgress,
          });
        }

        if (data.graded_data) {
          setGradedData({
            dayProgress: data.graded_data.dayProgress,
            weekProgress: data.graded_data.weekProgress,
            monthProgress: data.graded_data.monthProgress,
            yearProgress: data.graded_data.yearProgress,
          });
        }

        if (data.shiptoshore_data) {
          setShiptoShoreData({
            dayProgress: data.shiptoshore_data.dayProgress,
            weekProgress: data.shiptoshore_data.weekProgress,
            monthProgress: data.shiptoshore_data.monthProgress,
            yearProgress: data.shiptoshore_data.yearProgress,
          });
        }

        if (data.usage_data) {
          setUsageData({
            unusedAgg: data.usage_data.unusedAgg,
            gas: data.usage_data.gas,
            burnerIdleFuel: data.usage_data.burnerIdleFuel,
            fuel: data.usage_data.fuel,
            electricityOffline: data.usage_data.electricityOffline,
            electricity: data.usage_data.electricity,
            productionElectricity: data.usage_data.productionElectricity,
            idleElectricity: data.usage_data.idleElectricity,
          });
        }

        if (data.annual_plant_status) {
          setannualPlantStatusData({
            Production_Hrs: data.annual_plant_status.Production_Hrs,
            Idle_Hrs: data.annual_plant_status.Idle_Hrs,
            Breakdown_Hrs: data.annual_plant_status.Breakdown_Hrs,
            Offline_Hrs: data.annual_plant_status.Offline_Hrs,
          });
        }

        if (data.train_load_data) {
          setTrainLoad({
            dayProgress: data.train_load_data.dayProgress,
            weekProgress: data.train_load_data.weekProgress,
            monthProgress: data.train_load_data.monthProgress,
            yearProgress: data.train_load_data.yearProgress,
          });
        }
        if (data.ship_load_data) {
          setShipLoad({
            dayProgress: data.ship_load_data.dayProgress,
            weekProgress: data.ship_load_data.weekProgress,
            monthProgress: data.ship_load_data.monthProgress,
            yearProgress: data.ship_load_data.yearProgress,
          });
        }
        if (data.ship_unload_data) {
          setShipUnload({
            dayProgress: data.ship_unload_data.dayProgress,
            weekProgress: data.ship_unload_data.weekProgress,
            monthProgress: data.ship_unload_data.monthProgress,
            yearProgress: data.ship_unload_data.yearProgress,
          });
        }

        if (data.batch_quality_data) {
          setBatchQualityData({
            Day_Good_Quality: data.batch_quality_data.Day_Good_Quality,
            Day_Bad_Quality: data.batch_quality_data.Day_Bad_Quality,
            Week_Good_Quality: data.batch_quality_data.Week_Good_Quality,
            Week_Bad_Quality: data.batch_quality_data.Week_Bad_Quality,
            Month_Good_Quality: data.batch_quality_data.Month_Good_Quality,
            Month_Bad_Quality: data.batch_quality_data.Month_Bad_Quality,
            Year_Good_Quality: data.batch_quality_data.Year_Good_Quality,
            Year_Bad_Quality: data.batch_quality_data.Year_Bad_Quality,
          });
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchData = async () => {
      const gatewayName = await fetchGatewayName();
      if (gatewayName) {
        const data = await fetchAnnualTotalisersData(gatewayName);
        setAnnualTotalisersData(data);
      }
    };

    // Execute the data fetching in sequence
    const executeDataFetching = async () => {
      const siteType = await fetchSiteData(); // Get site type from fetchSiteData
      await fetchTimestreamData(siteType); // Pass site type to fetchTimestreamData
      await fetchData();
    };

    executeDataFetching();

    // Set up interval for auto-refresh (every 2 minutes)
    const intervalId = setInterval(() => {
      setLoading(true);
      executeDataFetching();
    }, 1000000);

    return () => clearInterval(intervalId);
  }, [site_id]);

  // Helper function to calculate grid size dynamically
  const calculateProductionCardGridSize = (count) => {
    if (count === 0) return 0;
    return Math.floor(12 / count); // evenly divide 12 columns
  };

  const productionCardKeys = [
    "Asphalt",
    "RAP",
    "Raw Material",
    "Sand",
    "Graded",
    "Batch Quality",
    "Ship to Shore",
  ];

  const visibleProductionCards = productionCardKeys.filter((item) =>
    dashboardConfig?.includes(item)
  );

  const productionCardSize = calculateProductionCardGridSize(visibleProductionCards.length);

  // Get array of visible usage cards
  const visibleUsageCards = [
    "Unused Agg.",
    "Gas Per Tonnage",
    "Burner Idle Fuel",
    "Fuel per Tonnage",
    "Electricity per Tonnage",
    "Electricity Offline",
    "Production Electricity",
    "Idle Electricity",
  ];

  // Calculate how many usage cards are visible
  const visibleUsageCount = visibleUsageCards.filter((item) =>
    dashboardConfig?.includes(item)
  ).length;

  // Calculate grid size for usage cards
  const usageCardSize = visibleUsageCount > 0 ? Math.floor(12 / visibleUsageCount) : 2;

  // Calculate how many ship/train cards are visible
  const visibleShipCount = ["Ship Loading", "Ship Unloading"].filter((item) =>
    dashboardConfig?.includes(item)
  ).length;
  const shipCardSize = visibleShipCount > 0 ? Math.floor(12 / visibleShipCount) : 0;

  return (
    <DashboardLayout>
      {/* Loading Spinner Overlay */}
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress color="inherit" />
        </div>
      )}

      {/* Navbar */}
      <div style={{ zIndex: 10000, position: "relative" }}>
        <DashboardNavbar />
      </div>

      <div style={{ filter: loading ? "blur(5px)" : "none", transition: "filter 0.3s ease" }}>
        {/* Top Row */}
        <VuiBox mb={1}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} md={6} lg={3}>
              <SiteInformation siteId={site_id} siteData={siteData} timestamp={timestamp} />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3}>
              <AnnualPlantStatus
                Production_Hrs={annualPlantStatusData.Production_Hrs}
                Idle_Hrs={annualPlantStatusData.Idle_Hrs}
                Breakdown_Hrs={annualPlantStatusData.Breakdown_Hrs}
                Offline_Hrs={annualPlantStatusData.Offline_Hrs}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3}>
              <PpmSummary siteId={site_id} isIncluded={dashboardConfig?.includes("PPM Summary")} />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3}>
              <LivePlantStatus
                plantState={
                  parseInt(livePlantStatusData) === 0
                    ? "offline"
                    : parseInt(livePlantStatusData) === 1
                      ? "breakdown"
                      : parseInt(livePlantStatusData) === 2
                        ? "idle"
                        : parseInt(livePlantStatusData) === 3
                          ? "production"
                          : "offline"
                }
              />
            </Grid>
          </Grid>
        </VuiBox>

        <VuiBox mb={1}>
          <Grid container spacing={1}>
            {productionCardSize > 0 && (
              <>
                {dashboardConfig?.includes("Batch Quality") && (
                  <Grid item xs={12} sm={12} md={12} lg={productionCardSize}>
                    <AsphaltBatchQuality batchQualityData={batchQualityData} />
                  </Grid>
                )}
                {dashboardConfig?.includes("Asphalt") && (
                  <Grid item xs={12} sm={12} md={12} lg={productionCardSize}>
                    <ProductionCardAsp
                      site_id={site_id}
                      title="Asphalt"
                      dayProgress={asphaltData.dayProgress}
                      weekProgress={asphaltData.weekProgress}
                      monthProgress={asphaltData.monthProgress}
                      yearProgress={asphaltData.yearProgress}
                      color="#0075FF"
                      unit="T"
                      productionCardSize={productionCardSize}
                    />
                  </Grid>
                )}

                {dashboardConfig?.includes("RAP") && (
                  <Grid item xs={12} sm={12} md={12} lg={productionCardSize}>
                    <ProductionCardRAP
                      title="RAP"
                      RAP_Utilisation_Day={rapData.dayProgress}
                      RAP_Utilisation_Week={rapData.weekProgress}
                      RAP_Utilisation_Month={rapData.monthProgress}
                      RAP_Utilisation_Year={rapData.yearProgress}
                      color="#D5ED9F"
                      unit="T"
                      maxDayValue={rapData.maxDayValue}
                      maxWeekValue={rapData.maxWeekValue}
                      maxMonthValue={rapData.maxMonthValue}
                      maxYearValue={rapData.maxYearValue}
                      productionCardSize={productionCardSize}
                    />
                  </Grid>
                )}

                {dashboardConfig?.includes("Raw Material") && (
                  <Grid item xs={12} sm={12} md={12} lg={productionCardSize}>
                    <ProductionCardRawMat
                      title="Raw Material"
                      Raw_Material_Day={RawMaterialData.dayProgress}
                      Raw_Material_Week={RawMaterialData.weekProgress}
                      Raw_Material_Month={RawMaterialData.monthProgress}
                      Raw_Material_Total={RawMaterialData.yearProgress}
                      color="#A020F0"
                      unit="T"
                      maxDayValue={RawMaterialData.maxDayValue}
                      maxWeekValue={RawMaterialData.maxWeekValue}
                      maxMonthValue={RawMaterialData.maxMonthValue}
                      maxYearValue={RawMaterialData.maxYearValue}
                      productionCardSize={productionCardSize}
                    />
                  </Grid>
                )}

                {dashboardConfig?.includes("Sand") && (
                  <Grid item xs={12} sm={12} md={12} lg={productionCardSize}>
                    <ProductionCardSand
                      title="Sand"
                      Sand_Day={SandData.dayProgress}
                      Sand_Week={SandData.weekProgress}
                      Sand_Month={SandData.monthProgress}
                      Sand_Total={SandData.yearProgress}
                      color="#C2B280"
                      unit="T"
                      maxDayValue={SandData.maxDayValue}
                      maxWeekValue={SandData.maxWeekValue}
                      maxMonthValue={SandData.maxMonthValue}
                      maxYearValue={SandData.maxYearValue}
                      productionCardSize={productionCardSize}
                    />
                  </Grid>
                )}

                {dashboardConfig?.includes("Graded") && (
                  <Grid item xs={12} sm={12} md={12} lg={productionCardSize}>
                    <ProductionCardGraded
                      title="Graded"
                      Graded_Day={GradedData.dayProgress}
                      Graded_Week={GradedData.weekProgress}
                      Graded_Month={GradedData.monthProgress}
                      Graded_Total={GradedData.yearProgress}
                      color="#FFA500"
                      unit="T"
                      maxDayValue={GradedData.maxDayValue}
                      maxWeekValue={GradedData.maxWeekValue}
                      maxMonthValue={GradedData.maxMonthValue}
                      maxYearValue={GradedData.maxYearValue}
                      productionCardSize={productionCardSize}
                    />
                  </Grid>
                )}

                {dashboardConfig?.includes("Ship to Shore") && (
                  <Grid item xs={12} sm={12} md={12} lg={productionCardSize}>
                    <ProductionCardShiptoShore
                      title="Ship to Shore"
                      ShiptoShore_Day={ShiptoShoreData.dayProgress}
                      ShiptoShore_Week={ShiptoShoreData.weekProgress}
                      ShiptoShore_Month={ShiptoShoreData.monthProgress}
                      ShiptoShore_Total={ShiptoShoreData.yearProgress}
                      color="#20B2AA"
                      unit="T"
                      maxDayValue={ShiptoShoreData.maxDayValue}
                      maxWeekValue={ShiptoShoreData.maxWeekValue}
                      maxMonthValue={ShiptoShoreData.maxMonthValue}
                      maxYearValue={ShiptoShoreData.maxYearValue}
                      productionCardSize={productionCardSize}
                    />
                  </Grid>
                )}
              </>
            )}
          </Grid>
        </VuiBox>
        {dashboardConfig?.includes("Train Loading") && (
          <VuiBox mb={1}>
            <Grid container spacing={1}>
              {dashboardConfig?.includes("Train Loading") && (
                <Grid item xs={12} sm={12} lg={12}>
                  <ProductionCardTrainLoad
                    title="Train Loading"
                    siteId={site_id} // Add this line to pass the site ID
                    Ship_Week={TrainLoadData.weekProgress}
                    Ship_Month={TrainLoadData.monthProgress}
                    Ship_Total={TrainLoadData.yearProgress}
                    color="#FFA500"
                    unit="T"
                    maxWeekValue={TrainLoadData.maxWeekValue}
                    maxMonthValue={TrainLoadData.maxMonthValue}
                    maxYearValue={TrainLoadData.maxYearValue}
                    shipTrainCardSize={productionCardSize}
                  />
                </Grid>
              )}
            </Grid>
          </VuiBox>
        )}
        {/* Usage Cards Section - Using dynamic grid sizing */}
        {visibleUsageCount > 0 && (
          <VuiBox mb={1}>
            <Grid container spacing={1}>
              {dashboardConfig?.includes("Unused Agg.") && (
                <Grid item xs={12} sm={4} md={usageCardSize + 2} lg={usageCardSize}>
                  <UsageCard
                    title="Unused Agg."
                    color="#5E5CE6"
                    value={Number(usageData.unusedAgg).toFixed(2)}
                    maxValue={0.1}
                    unit="T / yr"
                  />
                </Grid>
              )}
              {dashboardConfig?.includes("Gas Per Tonnage") && (
                <Grid item xs={12} sm={4} md={usageCardSize + 2} lg={usageCardSize}>
                  <UsageCard
                    title="Gas Per Tonnage"
                    color="#73CAC5"
                    value={Number(usageData.gas).toFixed(2)}
                    maxValue={0.1}
                    unit="kWh"
                  />
                </Grid>
              )}
              {dashboardConfig?.includes("Burner Idle Fuel") && (
                <Grid item xs={12} sm={4} md={usageCardSize + 2} lg={usageCardSize}>
                  <UsageCard
                    title="Burner Idle Fuel"
                    color="#C63C51"
                    value={Number(usageData.burnerIdleFuel).toFixed(2)}
                    maxValue={0.1}
                    unit="Litres"
                  />
                </Grid>
              )}
              {dashboardConfig?.includes("Fuel per Tonnage") && (
                <Grid item xs={12} sm={4} md={usageCardSize + 2} lg={usageCardSize}>
                  <UsageCard
                    title="Fuel per Tonnage"
                    color="#CAB773"
                    value={Number(usageData.fuel).toFixed(2)}
                    maxValue={0.1}
                    unit="Litres"
                  />
                </Grid>
              )}
              {dashboardConfig?.includes("Electricity per Tonnage") && (
                <Grid item xs={12} sm={4} md={usageCardSize + 2} lg={usageCardSize}>
                  <UsageCard
                    title="Electricity per Tonnage"
                    color="#F0F477"
                    value={Number(usageData.electricity).toFixed(2)}
                    maxValue={0.1}
                    unit="kWh"
                  />
                </Grid>
              )}
              {dashboardConfig?.includes("Electricity Offline") && (
                <Grid item xs={12} sm={4} md={usageCardSize + 2} lg={usageCardSize}>
                  <UsageCard
                    title="Electricity Offline"
                    color="#F0A8D0"
                    value={Number(usageData.electricityOffline).toFixed(2)}
                    maxValue={0.1}
                    unit="kWh"
                  />
                </Grid>
              )}
              {dashboardConfig?.includes("Production Electricity") && (
                <Grid item xs={12} sm={4} md={usageCardSize + 2} lg={usageCardSize}>
                  <UsageCard
                    title="Production Electricity"
                    color="#4CAF50"
                    value={Number(usageData.productionElectricity || 0).toFixed(2)}
                    maxValue={0.1}
                    unit="MWh"
                  />
                </Grid>
              )}

              {dashboardConfig?.includes("Idle Electricity") && (
                <Grid item xs={12} sm={4} md={usageCardSize + 2} lg={usageCardSize}>
                  <UsageCard
                    title="Idle Electricity"
                    color="#FF9800"
                    value={Number(usageData.idleElectricity || 0).toFixed(2)}
                    maxValue={0.1}
                    unit="MWh"
                  />
                </Grid>
              )}
            </Grid>
          </VuiBox>
        )}

        {/* Line Chart Section */}
        <VuiBox mb={1}>
          <Grid container spacing={1}>
            <Grid item xs={12} lg={12} xl={6}>
              <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                <VuiBox display="flex" flexDirection="column" height="100%" p={2}>
                  <VuiTypography variant="lg" color="white" fontWeight="bold">
                    Annual Totalisers
                  </VuiTypography>
                  <VuiBox display="flex" alignItems="center" mb="40px">
                    {/* Content here */}
                  </VuiBox>
                  <VuiBox sx={{ height: "100%" }}>
                    <AnnualTotalisersChart data={annualTotalisersData} />
                  </VuiBox>
                </VuiBox>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} lg={6} xl={3} sx={{ minHeight: "350px" }}>
              <ConditionMonitoring />
            </Grid>
            <Grid item xs={12} sm={6} lg={6} xl={3} sx={{ minHeight: "350px" }}>
              <StockedMaterials materials={stockedMaterialsData} />
            </Grid>
          </Grid>
        </VuiBox>

        {/* Ship and Train Section but Show each card if included in dashboardConfig */}
        {(dashboardConfig?.includes("Ship Loading") ||
          dashboardConfig?.includes("Ship Unloading")) && (
          <VuiBox mb={1}>
            <Grid container spacing={1}>
              {dashboardConfig?.includes("Ship Unloading") && (
                <Grid item xs={12} sm={12} lg={shipCardSize}>
                  <ProductionCardShipUnload
                    title="Ship Unloading"
                    Ship_Week={ShipUnloadData.weekProgress}
                    Ship_Month={ShipUnloadData.monthProgress}
                    Ship_Total={ShipUnloadData.yearProgress}
                    color="#FFA500"
                    unit="T"
                    maxWeekValue={ShipUnloadData.maxWeekValue}
                    maxMonthValue={ShipUnloadData.maxMonthValue}
                    maxYearValue={ShipUnloadData.maxYearValue}
                    shipTrainCardSize={productionCardSize}
                  />
                </Grid>
              )}
              {dashboardConfig?.includes("Ship Loading") && (
                <Grid item xs={12} sm={12} lg={shipCardSize}>
                  <ProductionCardShipLoad
                    title="Ship Loading"
                    Ship_Week={ShipLoadData.weekProgress}
                    Ship_Month={ShipLoadData.monthProgress}
                    Ship_Total={ShipLoadData.yearProgress}
                    color="#FFA500"
                    unit="T"
                    maxWeekValue={ShipLoadData.maxWeekValue}
                    maxMonthValue={ShipLoadData.maxMonthValue}
                    maxYearValue={ShipLoadData.maxYearValue}
                    shipTrainCardSize={productionCardSize}
                  />
                </Grid>
              )}
            </Grid>
          </VuiBox>
        )}

        <Footer />
      </div>
    </DashboardLayout>
  );
}

export default Dashboard;
